// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBpYmpLcE2tvAUr9AJBDjEOJ7AS8JTKSMs",
  authDomain: "parla-psykperspektiv.firebaseapp.com",
  projectId: "parla-psykperspektiv",
  storageBucket: "parla-psykperspektiv.firebasestorage.app",
  messagingSenderId: "706561430074",
  appId: "1:706561430074:web:df3051e164dc483ee25b03"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };